<template>
    <div>
    <a href="whatsapp://send?text=This is WhatsApp sharing example using link" data-action="share/whatsapp/share"  
        target="_blank"> Share to WhatsApp </a>   

        <button onclick="window.open(`whatsapp://send?text=Check out this link 'https://app.pickiddo.com/v3/%23/ExamDetail?guidId%3D${this.extractString}`)" id="whatsapp-mobile"> Open WhatsApp </button>
        <button onclick="window.open(`https://web.whatsapp.com/send?text=Check out this link 'https://app.pickiddo.com/v3/#/ExamDetail?guidId=${this.extractString}`)" id="whatsapp-desktop"> Open WhatsApp Web </button> 

        <!-- <button id="whatsapp-mobile" v-bind:onclick="isMobile ? openWhatsApp : ''">Open WhatsApp App</button>
        <button id="whatsapp-desktop" v-bind:onclick="isMobile ? '' : openWhatsApp">Open WhatsApp Web</button> -->


       
    
    <div>
      <Mainlayout></Mainlayout>
      <div class="c-app flex-row align-items-center">
        <CContainer style="display: flex; justify-content: center" class="p-0">
          <div class="container-box center">
            <div class="text-center">
              <img
                style="max-height: 300px"
                src="../assets/img/icon/onlineexam.png"
              />
            </div>
  
            <CCol sm="12" class="ml-3 mr-3 mt-3">
              <label>To enable your friend to take the exam, share the link with them</label>
              <div class="text-left mt-3">
                <CRow>
                  <span class="width:20%">
                    <img src="../assets/img/icon/book.svg" />
                  </span>
                  <span class="width:80%">
                    <span class="header-title-info ml-2">Sharing Link</span>
                    <br /><br />
                  </span>
                </CRow>
                <CRow>
                  <CCol sm="12">
                    <CRow>
                      <CCol sm="8">
                        <CInput
                          type="text"
                          v-model="linkShare"
                          style="max-width: 100% !important"
                          placeholder="Enter your link"
                        />
                      </CCol>
                      <CCol sm="2">
                        <CButton style="max-width:100%" color="info" class="btn-select-blue-custom" @click="copyLink"
                          >Share</CButton
                        >
                      </CCol>
                      <CCol sm="2">
                      <img style="max-height:50px" src="../assets/img/icon/whatsap.png" @click="GoToApp" id="whatsapp-mobile">
     <img style="max-height:50px" src="../assets/img/icon/whatsap.png"  @click="GoToWebs()" id="whatsapp-desktop"/>

                      
                        
                        
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>
              </div>
            </CCol>
            <hr />
            <CCol sm="12" class="ml-3 mr-3 mt-3">
              <div class="text-left">
                <CRow>
                  <span class="width:20%">
                    <img src="../assets/img/icon/book.svg" />
                  </span>
                  <span class="width:80%">
                    <span class="header-title-info ml-2"
                      >You may start to answer exam based on selection subject and
                      grade.</span
                    >
                    <br /><br />
                  </span>
                </CRow>
                <CRow>
                  <CCol sm="12">
                      <div v-if="linkShare != null">
                          <CButton type="button" color="success" :href="linkShare">Take Exam</CButton>
                      </div>
                      <div v-else>
                          <CButton type="button" color="success" disabled>Take Exam</CButton>
                      </div>
                   
                  </CCol>
                </CRow>
              </div>
            </CCol>
            <hr />
            <CCol sm="12" class="ml-3 mr-3 mt-3">
              <div class="text-left">
                <CRow>
                  <span class="width:20%">
                    <img src="../assets/img/icon/book.svg" />
                  </span>
                  <span class="width:80%">
                    <span class="header-title-info ml-2"
                      >Let's see who score highest</span
                    >
                    <br /><br />
                  </span>
                </CRow>
                <CRow>
                  <CCol sm="12">
                      <div v-if="linkShare != null">
                          <CButton type="button" color="success" @click="GoToLeaderboard">Visit Leaderboard</CButton>
                      </div>
                      <div v-else>
                          <CButton type="button" color="success" disabled>Visit Leaderboard</CButton>
                      </div>
                   
                  </CCol>
                </CRow>
              </div>
            </CCol>
  
            <!-- <div class="text-center mt-4 mb-5">
              <CButton
                color="info"
                class="btn-select-blue"
                @click="StudentTakeExam"
                >Take Exam</CButton
              >
            </div> -->
          </div>
        </CContainer>
      </div>
    </div>
    </div>
  </template>
      
      <script>
  import Vue from "vue";
  import _ from "lodash";
  import vSelect from "vue-select";
  Vue.component("v-select", vSelect);
  import "vue-select/dist/vue-select.css";
  import "vue-select/src/scss/vue-select.scss";
  import Mainlayout from "../containers/TheHeaderExam.vue";
  
  export default {
    components: {
      Mainlayout,
    },
    data: function () {
      return {
        linkShare: 'https://app.pickiddo.com/v3/#/ExamDetail?guidId=' + this.$route.query.guidId,
        links: this.$route.query.guidId,
        guidId: "",
      };
    },
    computed: {
      extractString() {
        const startIndex = this.linkShare.lastIndexOf('=') + 1;
        return this.linkShare.substring(startIndex);
      },
      isMobile() {
      return window.innerWidth < 768;
    }
    },
    // created() {
    //   // extract guidId parameter from URL
    //  // const urlParams = new URLSearchParams(window.location.search);
    //   const currentUrl = window.location.href;
    //   this.guidId = currentUrl.get('guidId');
  
    //   const currentUrls = window.location.href;
    //   console.log('Current URL:', currentUrls);
    // },
    async mounted() {
      this.GetListSubject();
      this.GetListGrade();
    },
    methods: {
      async GetListSubject() {
        this.$API.get(this.$QuizSubjectList).then((response) => {
          if (response.status == 200 && response.data != null) {
            this.subjects = response.data;
            console.log("test" + extractString);
          }
        });
      },
      async GetListGrade() {
        this.$API.get(this.$QuizGradeList).then((response) => {
          if (response.status == 200 && response.data != null) {
            this.grades = response.data;
          }
        });
      },
      GetQuizDetail() {
        this.$API
          .get(this.$QuizPreview + "?quizId=" + this.$route.query.quizId)
          .then((response) => {
            if (response.status == 200 && response.data != null) {
              this.quiz = response.data;
            }
          });
      },
      GoToInfoQuiz() {
        this.$router.push("AnswerQuizAll?quizId=" + this.$route.query.quizId);
      },
  
      StudentStartQuiz() {
        const formData = new FormData();
        formData.append("quizId", this.$route.query.quizId);
        formData.append("studentId", "12190");
  
        return this.$API
          .post(this.$StudentStartQuiz, formData)
          .then((response) => {
            if (response.status == 200 && response.data != null) {
              var startId = response.data;
              this.getNow(this.quiz.d, this.quiz.h, this.quiz.m, this.quiz.s);
              console.log(this.timestamp);
              this.GoToQuiz(startId);
            }
          })
          .catch((error) => {
            if (error.response) {
              this.Busy = false;
              this.Error = true;
            }
          });
      },
  
      StudentTakeExam() {
        const formData = new FormData();
        formData.append("Name", this.Name);
        formData.append("Email", this.Email);
        formData.append("PhoneNumber", this.PhoneNumber);
        formData.append("subjectId", this.$route.query.subjectId);
        formData.append("gradeId", this.$route.query.gradeId);
  
        return this.$API
          .post(this.$StudentSubmitExam, formData)
          .then((response) => {
            if (response.status == 200 && response.data != null) {
              var startId = response.data;
              this.GetGuiExam(startId);
            }
          })
          .catch((error) => {
            if (error.response) {
              this.Busy = false;
              this.Error = true;
            }
          });
      },
      GetGuiExam(startId) {
        this.$API
          .get(this.$GetGuiExam + "?startId=" + startId)
          .then((response) => {
            if (response.status == 200 && response.data != null) {
              this.quiz = response.data;
              this.GoToQuiz(startId, this.quiz);
            }
          });
      },
      GoToQuiz(startId, quiz) {
        this.$router.push(
          //   "/QuestionExamBank?subjectId=" +
          //   this.$route.query.subjectId +
          //     "&gradeId=" +
          //     this.$route.query.gradeId +
          //     "&startId=" +
          //     startId
  
          "/QuestionExamBank?guidId=" + quiz + "&startId=" + startId
        );
      },
      GoToLeaderboard()
      {
          this.$router.push("ExamLeaderboard?" + this.extractString);
      },
      copyLink() {
        navigator.clipboard.writeText(this.linkShare);
      },
      
      // GotoWhatsap() {
      //   location.replace(
      //     "https://wa.me/600106597700?text=+" + this.linkShare
      //   );
      // },
    //   shareOnWhatsApp() {
    //       const message = encodeURIComponent("Check out this link!");
    //       const shareUrl = `https://web.whatsapp.com/send?text=${message}%20${this.linkShare}`;
    //       const isWhatsAppInstalled = this.isAppInstalled("whatsapp");
  
    //       if (isWhatsAppInstalled) {
    //         window.open = `'whatsapp://send?text=${message}%20${this.linkShare}`;
    //       } else {
    //           window.open(shareUrl);
    //       }
    //   },
  
    //   isAppInstalled(scheme) {
    //       const regex = new RegExp(`${scheme}:`);
    //       return regex.test(window.navigator.userAgent.toLowerCase());
    //   },
    //   openWhatsApp() {
    //   if (this.isMobile) {
    //     var message = encodeURIComponent("Check out this link!");
    //     var linkshares = this.linkShare;
    //     window.open(`whatsapp://send?text=${message}%20${linkshares}`);
    //   } else {
    //     window.open('https://web.whatsapp.com://send?text=${message}%20${linkshares}');
    //   }
    // },
       GoToApp()
      {

        const myParamValue = this.extractString;
const encodedParamValue = encodeURIComponent(myParamValue);
//const url = `https://example.com/my-page?myParam=${encodedParamValue}`;


        window.open(`whatsapp://send?text=Check out this message https://app.pickiddo.com/v3/%23/ExamDetail?guidId%3D${encodedParamValue}`);

      },
      GoToWebs()
      {
        var linkshares = this.linkShare;
        window.open(`https://web.whatsapp.com/send?text=Check out this message%20${this.linkShare}`);
      }

      }
  };
  </script>
      
      <style scoped>
  @import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
  
  body {
    font-family: "Montserrat", sans-serif;
  }
  .card-custom-web {
    max-width: 700px;
    left: 0px;
    margin-top: 129px;
    height: 100vh;
  
    /* Off white */
  
    background: #f9f9f9;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
    border-radius: 32px 0px 0px 0px;
    color: #000;
  }

  @media only screen and (max-width: 768px) {
  #whatsapp-mobile {
    display: block;
  }
  #whatsapp-desktop {
    display: none;
  }
}
  @media only screen and (min-width: 769px) {
  #whatsapp-mobile {
    display: none;
  }
  #whatsapp-desktop {
    display: block;
  }
}

  </style>

